// @flow
import React, { Fragment } from "react";
import { withGlobalContext } from "../common/GlobalContext";
import type { $Site, $Agent, SiteOffice, $Team } from "flow/types";

type $Props = {
  agent: $Agent,
  headerNav: string,
  office: SiteOffice,
  site: $Site,
  team: $Team,
};

const RenderContactInfo = ({
  site,
  agent,
  office,
  team,
  headerNav,
}: $Props) => {
  let phoneHref;
  let phone;
  let email;
  let name;

  if (site.userId && agent) {
    phoneHref = agent.cellPhone;
    phone = agent.cellPhoneFormatted;
    email = agent.email;
    name = `
      ${
        agent.fullName ? agent.fullName : `${agent.firstName} ${agent.lastName}`
      }${office && office.name && `, ${office.name}`}`;
  } else if (site.teamId && team) {
    phoneHref = team.cellPhone;
    phone = team.cellPhoneFormatted;
    email = team.email;
    name = team.name;
  } else if (office) {
    phoneHref = office.officePhone;
    phone = office.officePhoneFormatted;
    email = office.email;
    name = office.name;
  }

  if (
    headerNav === "threeColumnNavBar" ||
    headerNav === "officeLogoRightSideNavBar"
  ) {
    return (
      <Fragment>
        {name && (
          <span
            style={{
              display: "block",
              marginBottom: "12px",
            }}
          >
            {name}
          </span>
        )}
        {phoneHref && phone ? (
          <a
            style={{
              display: "inline-block",
              paddingBottom: "8px",
            }}
            href={`tel:${phoneHref}`}
          >
            <span>Phone: {phone}</span>
          </a>
        ) : null}
        <br />
        {email ? (
          <a href="/contact">
            <span>Email: {email}</span>
          </a>
        ) : null}
      </Fragment>
    );
  }

  return (
    <Fragment>
      {phoneHref && phone ? (
        <a href={`tel:${phoneHref}`}>
          <span>{phone}</span>
        </a>
      ) : null}
      {email ? (
        <a href="/contact">
          <span>{email}</span>
        </a>
      ) : null}
    </Fragment>
  );
};

export default withGlobalContext(RenderContactInfo);
